<template>
    <div class="preview-hub">
        <div class="preview-tabs" v-if="tabs.length > 1">
            <router-link v-for="tab in tabs" :key="tab.name"
                         :to="{ name: tab.name }"
                         tag="button" type="button"
                         class="btn btn-text btn-fill"
                         active-class="active">
                {{ tab.label }}
            </router-link>
        </div>
        <router-view :key="$route.path"></router-view>
    </div>
</template>
<script>
const TABS = [
    {name: 'preview-templates', label: 'Шаблоны', admin: false},
    {name: 'preview-carousels', label: 'Карусели', admin: true},
    {name: 'preview-stories', label: 'Сторис', admin: true},
    {name: 'preview-graphics', label: 'Стикеры', admin: true},
    {name: 'preview-frames', label: 'Фреймы', admin: true},
];

export default {
    data() {
        return {
            role: parseInt(localStorage.getItem('role')) || 0,
        }
    },
    computed: {
        tabs: function () {
            const isAdmin = this.role === 302;
            return TABS.filter(function (tab) {
                return isAdmin || !tab.admin;
            });
        },
    },
}
</script>
<style scoped>

.preview-tabs {
    padding: 30px 15px 0;
}

.preview-hub >>> .content {
    padding-top: 16px;
}

.btn-text,
.btn-text:active,
.btn-text:hover,
.btn-text:focus {
    color: #000;
    background-color: #FFFFFF;
    border: 1px solid #000000;
    margin-right: 5px;
    margin-bottom: 5px;
}

.btn-text.active {
    color: #000;
    background-color: #D5C9E9;
    border: 1px solid #D5C9E9;
}

.btn-text:hover {
    opacity: 0.6;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/PreviewHub.vue